import React, { memo, useMemo } from "react";

import Cartao from "../../UI/Cartao";

import { servicos } from "../../utils/servicos";
import { footerTexts } from "../../utils/footerConstants";

const Servicos = () => {
  const cardsServicos = useMemo(() => {
    if (!Array.isArray(servicos) || servicos.length === 0) {
      return null;
    }

    return servicos.map((item, index) => {
      const message = `Olá! Vim pelo site da Clínica e gostaria de agendar uma avaliação para ${item.titulo}.`;

      const whatsappUrl = `https://wa.me/${
        footerTexts.phone
      }?text=${encodeURIComponent(message)}`;

      return (
        <li
          key={item.id || `servico-${index}`}
          className="servico-card-wrapper"
          style={{ "--index": index }}
        >
          <Cartao
            icone={item.icone}
            titulo={item.titulo}
            descricao={item.descricao}
            badgeText={item.categoria}
            className="servico-card"
          >
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="servico-card__btn"
              aria-label={`Agendar avaliação para ${item.titulo}`}
            >
              QUERO AGENDAR UMA AVALIAÇÃO
            </a>
          </Cartao>
        </li>
      );
    });
  }, []);

  return (
    <section
      id="servicos"
      className="servicos-wrapper"
      aria-labelledby="servicos-title"
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-delay="140"
    >
      {/* =========================
          HEADER
      ========================= */}
      <header className="servicos-header">
        <span className="servicos-subtitle">
          Especialidades
        </span>

        <h2
          className="servicos-title"
          id="servicos-title"
        >
          TRATAMENTOS COM FOCO EM {" "}
          <span className="servicos-highlight">
             NATURALIDADE
          </span>
        </h2>

        <p className="servicos-description">
          Protocolos personalizados realizados
          pela Dra. Fabiana Catarino com técnicas
          modernas, segurança e resultados elegantes.
        </p>
      </header>

      {/* =========================
          GRID
      ========================= */}
      {cardsServicos ? (
        <ul
          className="servicos-grid"
          role="list"
        >
          {cardsServicos}
        </ul>
      ) : (
        <div className="servicos-empty">
          <p>
            Nenhum tratamento disponível no
            momento.
          </p>
        </div>
      )}
    </section>
  );
};

export default memo(Servicos);